// extracted by mini-css-extract-plugin
export default {"diary":"App_diary__r-+xg"};